import React from 'react';
import { MessageCircle } from 'lucide-react';
import { companyInfo } from '../data/mockData';

const PREFILL = encodeURIComponent(
  "Hi SS Consultancy, I'd like to schedule a financial advisory consultation."
);

export const WhatsAppFloat = () => {
  const href = `https://wa.me/${companyInfo.whatsappRaw}?text=${PREFILL}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      data-testid="whatsapp-float-btn"
      aria-label="Chat with SS Consultancy on WhatsApp"
    >
      <span className="whatsapp-pulse" aria-hidden="true" />
      <MessageCircle size={20} strokeWidth={2.4} />
      <span className="whatsapp-label">Chat on WhatsApp</span>
    </a>
  );
};
